import { take, fork, put, call, select, delay} from 'redux-saga/effects';
import actionTypes from '../actionTypes';
import { callApi } from "./callApi";
import { successMessages, successAllMessages, successReadMessage, successSendMessage, successDeleteMessage } from "../actionCreators/messages";
import config from "../../config/config";
import {getAuthenticationStatus, getGlobalAccount, getCurrentClubPlayerToken, getGlobalToken} from "../selectors";
import {showNotification} from "../actionCreators/notification";
import { createBrowserHistory } from 'history';

const browserHistory = createBrowserHistory();
function* getMessages() {
    try {
        const {id: accountId, clubId: skinId, token} = yield select(getGlobalAccount);
        const params = {accountId, skinId, token, associated: true};

        const response = yield call(callApi, `${config.MESSAGES_API}/message`, 'GET', params);
        yield put(successMessages(response.data.result.messages));
    } catch (e) {}
}

function* getAllMessages({clubId}) {
    try {
        let token = yield select(getGlobalToken);
        const {id: accountId, clubId: skinId } = yield select(getGlobalAccount);
        if(clubId) {
            token = yield select(getCurrentClubPlayerToken);
        }
        const params = {accountId, skinId, token};

        const response = yield call(callApi, `${config.MESSAGES_API}/messages`, 'GET', params);
        yield put(successAllMessages(response.data.result.messages));
    } catch (e) {}
}

function* sendMessage({clubId, title, content}) {
    try {
        const token = yield select(getGlobalToken);
        const params = {
            accountId: clubId,
            type: 'splash',
            title,
            content,
            token
        };

        yield call(callApi, `${config.MESSAGES_API}/message`, 'POST', params);
        yield put(successSendMessage());
        yield put(showNotification({message: 'Successfully sent the message.'}));
    } catch (e) {}
}

function* markMessageAsRead( {messageId, accountId} ) {
    try {
        // const accountId = yield select(getCurrentAccountId);
        const token = yield select(getGlobalToken);
        const params = {
            status: 'read',
            accountId,
            messageId,
            token
        };
        yield call(callApi, `${config.MESSAGES_API}/subscribtion`, 'PATCH', params);
        yield put(successReadMessage({messageId, accountId}));
    } catch (e) {
        // need close read message dialog
    }
}

function* deleteMessages( messageIds ) {
    const token = yield select(getGlobalToken);
    try {
        yield call(callApi, `${config.MESSAGES_API}/messages`, 'DELETE', {messagesIds: messageIds, token});
        yield put(showNotification({message: 'Message Deleted'}));
        yield put(successDeleteMessage());
        yield  browserHistory.goBack();
    } catch (e) {}
}

export function* watchUnreadMessages() {
    while (true) {
        yield take(actionTypes.GET_UNREAD_MESSAGES_REQUEST);
        yield fork(getMessages);
    }
}

export function* watchAllMessages() {
    while (true) {
        const action = yield take(actionTypes.GET_MESSAGES_REQUEST, actionTypes.DELETE_MESSAGE_SUCCESS);
        yield fork(getAllMessages, action);
    }
}

export function* fetchMessagesByInterval() {
    while (true) {
        const isAuthenticated = yield select(getAuthenticationStatus);
        if( isAuthenticated ) {
            yield fork(getMessages);
        }
        yield delay(config.fetchDataIntervals.messages);
    }
}

export function* watchReadMessage() {
    while (true) {
        const action = yield take(actionTypes.READ_MESSAGE_REQUEST);
        yield fork(markMessageAsRead, {...action});
    }
}

export function* watchSendMessage() {
    while (true) {
        const action = yield take(actionTypes.SEND_MESSAGE_REQUEST);
        yield fork(sendMessage, action);
    }
}

export function* watchDeleteMessages() {
    while (true) {
        const action = yield take(actionTypes.DELETE_MESSAGE_REQUEST);
        yield fork(deleteMessages, action.messageIds);
    }
}